import { render } from "./ReviewSentModal.vue?vue&type=template&id=c82ab21c&scoped=true"
import script from "./ReviewSentModal.vue?vue&type=script&lang=js"
export * from "./ReviewSentModal.vue?vue&type=script&lang=js"

import "./ReviewSentModal.vue?vue&type=style&index=0&id=c82ab21c&scoped=true&lang=css"

import exportComponent from "/app/code_base/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c82ab21c"]])

export default __exports__